import React, { useState } from 'react';
import { Close, MoreVert } from '@mui/icons-material';
import { IconButton, Menu, MenuItem, Stack, Tooltip, Typography, useTheme } from '@mui/material';
import { TabDrawerTabProps } from './TabDrawerTab.props';
import { StyledTabDrawerTab } from './TabDrawerTab.style';

const TabDrawerTab = ({ icon, tabTitle, isActive, onClick, onClose, secondaryActions }: TabDrawerTabProps) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (action: () => void) => {
    action();
    handleMenuClose();
  };

  const iconColor = isActive ? theme.palette.primary.contrastText : theme.palette.primary.main;

  // Clone the icon element and apply the color style
  const styledIcon = React.isValidElement(icon)
    ? React.cloneElement(icon, {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      ...icon.props,
      fill: iconColor,
      style: {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        ...icon.props.style,
      },
    })
    : icon;

  return (
    <StyledTabDrawerTab
      onClick={onClick}
      style={{
        fontWeight: '700',
        backgroundColor: isActive ? theme.palette.primary.main : theme.palette.background.paper,
        color: isActive ? theme.palette.primary.contrastText : theme.palette.primary.main,
      }}>
      <Stack direction="row" alignItems="center" gap={1} sx={{ flex: 1, minWidth: 0 }}>
        {styledIcon}
        <Tooltip title={tabTitle} arrow placement="top">
          <Typography
            style={{
              color: isActive ? theme.palette.primary.contrastText : theme.palette.primary.main,
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              flex: 1,
              minWidth: 0,
            }}>
            {tabTitle}
          </Typography>
        </Tooltip>

        {secondaryActions && secondaryActions.length > 0 && (
          <>
            <IconButton
              onClick={handleMenuClick}
              size="small"
              sx={{
                color: isActive ? theme.palette.primary.contrastText : theme.palette.primary.main,
                padding: '2px',
              }}>
              <MoreVert sx={{ height: '0.875rem', width: '0.875rem' }} />
            </IconButton>
            <Menu
              anchorEl={anchorEl}
              open={open}
              onClose={handleMenuClose}
              transformOrigin={{ horizontal: 'right', vertical: 'top' }}
              anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}>
              {secondaryActions.map(action => (
                <MenuItem key={action.title} onClick={() => handleMenuItemClick(action.onClick)} dense>
                  {action.title}
                </MenuItem>
              ))}
            </Menu>
          </>
        )}

        {onClose && (
          <Close
            onClick={e => {
              e.stopPropagation();
              onClose();
            }}
            sx={{ height: '0.75rem', width: '0.75rem' }}
          />
        )}
      </Stack>
    </StyledTabDrawerTab>
  );
};

export default TabDrawerTab;
